import React from 'react';
import { Transaction } from '@/types/transaction';
import TransactionDescription from './TransactionDescription';
import TransactionFeeDetails from './TransactionFeeDetails';
import TransactionProcessingInfo from './TransactionProcessingInfo';
import TransactionIdInfo from './TransactionIdInfo';

interface TransactionDetailCardProps {
  transaction: Transaction;
  isKeepMoreTransaction: boolean;
}

const TransactionDetailCard: React.FC<TransactionDetailCardProps> = ({ 
  transaction, 
  isKeepMoreTransaction 
}) => {
  return (
    <div className="bg-[#F2F2F2] rounded-lg p-4 space-y-4">
      <TransactionDescription description={transaction.description} />
      
      {/* Fee details */}
      <TransactionFeeDetails transaction={transaction} />
      
      {/* KeepMore status */}
      <TransactionProcessingInfo isKeepMoreTransaction={isKeepMoreTransaction} />
      
      <TransactionIdInfo transaction={transaction} />
    </div>
  );
};

export default TransactionDetailCard;
